import { z } from 'zod';

export const programsSearchSchema = z.object({
  q: z.string().optional().catch(undefined),
});

export type ProgramsSearch = z.infer<typeof programsSearchSchema>;
